module.exports = __webpack_public_path__ + "static/Proteus Cyber-b3234b956fcd125629584c83bd47c386.jpg";